import React from 'react'

const CloseX = () => (
  <div className="close-x">✕</div>
)

export default CloseX



// WEBPACK FOOTER //
// ./src/views/misc/CloseX.js